import React from "react"
import { Link, useLocation } from "react-router-dom"
import { startsWith } from "lodash"
import {
  Banknote,
  Building2,
  ChartColumn,
  ClipboardList,
  FolderOpen,
  Handshake,
  Menu,
  Notebook,
  Package,
  User,
  House,
} from "lucide-react"

const Navigation = () => {
  const pathname = useLocation().pathname

  const renderNavItem = (name, link, icon) => {
    const isActive = link === pathname || (link != "/" && startsWith(pathname, link))
    return (
      <li className={`side-nav-item ${isActive && "menuitem-active"}`}>
        <Link to={link} className="side-nav-link">
          <div className="side-nav-icon-box">{icon}</div>

          <span className="ms-2">{name}</span>
        </Link>
      </li>
    )
  }

  return (
    <div className="leftside-menu menuitem-active text-start">
      <Link to="/" className="logo">
        <span className="logo-lg">
          <img src="/images/logo-catch.svg" />
        </span>
        {/* <span className="logo-sm">
          <img src="/images/logo-catch.svg" />
        </span> */}
      </Link>
      <ul className="side-nav">
        {renderNavItem("Home", "/", <House />)}
        <li className="side-nav-title">Group Sales</li>
        {renderNavItem("Areas", "/areas", <Building2 />)}
        {renderNavItem("Bookings", "/bookings", <Notebook />)}
        {renderNavItem("Clients", "/clients", <User />)}
        {renderNavItem("Packs", "/packs", <Package />)}
        {renderNavItem("Menus", "/menus", <Menu />)}
        {renderNavItem("Categories", "/categories", <FolderOpen />)}
        {renderNavItem("Line Items", "/line-items", <ClipboardList />)}
        {renderNavItem("Sponsorship", "/sponsorship", <Handshake />)}
        {renderNavItem("Payments", "/payments", <Banknote />)}
        {
          // renderNavItem("Clients", "/clients", "user")
        }
        {
          // <li className="side-nav-title">Corporate <sup>Coming Soon!</sup></li>
          // { renderNavItem("Partners", "/#partners", "pricetag-alt") }
          // { renderNavItem("Contracts", "/#contracts", "file") }
        }
        {
          // <li className="side-nav-title">Financials</li>
          // {renderNavItem("Payments", "/payments", <CreditCard />)}
        }

        <li className="side-nav-title">Insights</li>
        {/* {renderNavItem("Sales Report", "/insights/sales", <Receipt />)} */}
        {/* {renderNavItem("Booking Service Report", "/insights/bookings", <Notebook />)} */}
        {renderNavItem("Reports", "/reports", <ChartColumn />)}
      </ul>
      <div className="clearfix"></div>
    </div>
  )
}

export default Navigation
